<template>

<div>

      <app-navigator  @typeChenge="ParsContent = $event" :leftMenu='leftMenu' > </app-navigator>
      <v-container  >
        <router-view :key="$route.fullPath"></router-view>
     </v-container>
</div>

</template>

<script>




export default {
  data () {
    return {
      leftMenu: {
        title: "Ресурсы",
        items: [
         {name:"Список серверов", icon:"mdi-server", iconColor:"#273C51" , content:"auth", selected:false },
         {name:"Antigate", icon:"mdi-robot",iconColor:"yellow" , content:"antigate", selected:false },
         {name:"Proxy", icon:"mdi-arrow-decision",iconColor:"blue" , content:"antigate", selected:false },
         {name:"User Agent", icon:"mdi-google-chrome",iconColor:"green" , content:"antigate", selected:false },
         {content:"line"},
         {id:1,name:"Поиск групп", icon:"mdi-account-group", iconColor:"green", content:"parser_groups", selected:false },
         {id:2,name:"Поиск страниц", icon:"mdi-account-search", iconColor:"#273C51", content:"pages_search", selected:false },
         {id:3,name:"Поиск видео", icon:"mdi-file-video",iconColor:"red", content:"pars_video", selected:false },
         {id:4,name:"Парсер обсуждений",icon:"mdi-comment-processing-outline",iconColor:"yellow", content:"pars_topics", selected:false },
         {id:5,name:"Парсер постов",icon:"mdi-comment-multiple-outline",iconColor:"pink", content:"pars_posts", selected:false },
         {id:7,name:"Парсер страниц", icon:"mdi-target", iconColor:"#273C51", content:"parser_pages", selected:false },

         {content:"line"},

         {id:8,name:"Фильтры", icon:"mdi-filter", iconColor:"#18E4FF", content:"filters", selected:false },
         {id:9,name:"Мои процессы",icon:"mdi-content-save", iconColor:"#7218FF", count: "processes",  content:"history", selected:false },

        ]
      }
    }
  },


}
</script>

<style scoped >
  #content {

  }
</style>
